import { createSignal } from "solid-js";
import type remend from "remend";

import { lazyOptional } from "~/util/lazy_module";

type Remend = typeof remend;

// remend builds `new RegExp("(?<=[\p{L}\p{N}_])~...")` at module scope, and lookbehind is syntax
// WebKit only runs from Safari 16.4. Imported statically it threw while application.ts evaluated
// and took every Stimulus island on the page with it, including the patient signature pad. Both
// call sites must load it through here — one static import anywhere puts it back in the entry
// chunk and breaks signing on older iPads again.
export const loadRemend = lazyOptional(
  () => import("remend").then((module) => module.default),
  "remend-load-failed",
);

const [loaded, setLoaded] = createSignal<Remend | null>(null);
let started = false;

// Reactive view for synchronous render paths: null until the chunk lands, so callers fall back to
// raw text and recompute once it arrives.
//
// `started` defers the fetch to the first caller ON PURPOSE. Kicking the load off at module scope
// looks equivalent and is not: this module is statically imported by `content_renderer`, so every
// page in the app would fetch the chunk whether or not anything renders markdown.
export function useRemend() {
  if (!started) {
    started = true;
    void loadRemend().then((fn) => setLoaded(() => fn));
  }
  return loaded;
}
